import React from "react";
import data from "../assets/data.json";

const Timeline = () => {
  return (
    <div id="timeline">
      <div className="timelineBox">
        {data.experience.map((item, index) => (
          <TimelineItem
            year={item.year}
            heading={item.eduTitle}
            text={item.eduDescription}
            index={index}
            key={item.eduTitle}
            imgSrc={item.imgSrc}
          />
        ))}
      </div>
    </div>
  );
};

const TimelineItem = ({year, heading, text, index, imgSrc }) => (
  <div
    className={`timelineItem ${
      index % 2 === 0 ? "leftTimeline" : "rightTimeline"
    }`}
  >


    <div>
      <h3>Year:{year}</h3>
      <img src={imgSrc} alt={heading} />
      <h2>{heading}</h2>
      <p>{text}</p>
    </div>
  </div>
);

export default Timeline;
